package horcrux.frontend.common.extensions

import horcrux.common.ServerAppRoute
import horcrux.common.api.dtos.ChatPageID
import horcrux.frontend.common.configs.ApplicationConfigs

val ChatPageID.Companion.chatPageQueryStringBase
    get() = "?chatPageID="

fun ChatPageID.Companion.getChatPageServerAppURL(chatPageID: String): String =
    "${ApplicationConfigs.BACKEND_URL}/${ServerAppRoute.CHAT_PAGE.value}${ChatPageID.chatPageQueryStringBase}${chatPageID}"

val ChatPageID.Companion.chatPageBrowserAppBaseURL: String
    get() = "${ApplicationConfigs.FRONTEND_URL}/${ServerAppRoute.CHAT_PAGE.value}/${ChatPageID.chatPageQueryStringBase}"

val ChatPageID.chatPageBrowserAppURL: String
    get() = "${ChatPageID.chatPageBrowserAppBaseURL}${betterToString()}"
